import { createSvgIconComponent } from "../utils";
export var IconUpArrow = createSvgIconComponent({
  path: "M28.377 19.759l-8.97-9.5a.858.858 0 0 0-.623-.259.858.858 0 0 0-.623.259l-8.969 9.5a.68.68 0 0 0 .096 1.03.883.883 0 0 0 1.15-.086l8.346-8.841 8.347 8.84a.882.882 0 0 0 1.149.086.699.699 0 0 0 .29-.558.687.687 0 0 0-.193-.471z",
  viewBox: "3 0 30 30"
});